/**
 * Utility functions for cache-busting via version parameters
 */

// Get the app version from environment variable
export const getAppVersion = (): string => {
  return process.env.REACT_APP_VERSION || 'dev';
};

/**
 * Adds version parameter to a URL for cache-busting
 * @param url - The URL to add version to
 * @param forceVersion - Optional: force a specific version
 * @returns URL with version parameter
 */
export const addVersionToUrl = (url: string, forceVersion?: string): string => {
  if (!url) return url;
  
  // Don't add version to external URLs, data URLs, or blob URLs
  if (
    url.startsWith('http://') || 
    url.startsWith('https://') || 
    url.startsWith('data:') || 
    url.startsWith('blob:')
  ) {
    return url;
  }
  
  const version = forceVersion || getAppVersion();
  const separator = url.includes('?') ? '&' : '?';
  
  return `${url}${separator}v=${version}`;
};

/**
 * Adds version parameter to PUBLIC_URL assets
 * Useful for static assets in the public folder
 */
export const getVersionedPublicUrl = (path: string): string => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const fullPath = path.startsWith('/') ? path : `/${path}`;
  return addVersionToUrl(`${publicUrl}${fullPath}`);
};
